<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Payment Due</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="payment_due" type="text" placeholder="Payment due days" :class="{ 'is-danger': errors.payment_due }">
                    <span class="icon is-left">
                        <i class="far fa-calendar-alt"></i>
                    </span>
                    <p v-if="errors.payment_due" class="help is-danger">{{ errors.payment_due[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            payment_due: {
                get() {
                    return this.$store.getters.getNewPricePlan.payment_due
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'payment_due', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/PaymentDueInput.vue